import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAddClass = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 21,
	height: 15,
	viewBox: "0 0 21 15",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#4A5666",
		fillRule: "nonzero",
		d: "M3.395 1.5C2.348 1.5 1.5 2.327 1.5 3.346v8.308c0 1.02.848 1.846 1.895 1.846h14.21c1.047 0 1.895-.827 1.895-1.846V3.346c0-1.02-.848-1.846-1.895-1.846zM18 0a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-1v-1.5H8V15H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm-6 8h1v7h-1zm-3 3h7v1H9z"
	})
});
export default SvgAddClass;
